import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { TwButton } from '../../components/Button/TwButton'
import { TextInput } from '../LoginPage/TextInput'
import { DeleteAccountLayout } from './DeleteAccountLayout.component'
import { useDeleteAccountRequest } from './useDeleteAccountRequest.hook'

export const DeleteAccountRequest: React.FC = () => {
  const { t } = useTranslation()
  const { email, changeEmail, loading, sent, error, submit } = useDeleteAccountRequest()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    submit()
  }

  return (
    <DeleteAccountLayout title={t('deleteAccount.title')}>
      {sent ? (
        <p className="text-sm text-gray-600 text-center">{t('deleteAccount.sent')}</p>
      ) : (
        <form noValidate onSubmit={handleSubmit} className="flex flex-col">
          <p className="text-sm text-gray-600 text-center">{t('deleteAccount.description')}</p>
          <TextInput
            label={t('deleteAccount.emailLabel')}
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => changeEmail(e.target.value)}
            disabled={loading}
            error={Boolean(error)}
            helperText={error ? t(`deleteAccount.error.${error}`) : undefined}
            autoFocus
          />
          <TwButton type="submit" size="md" disabled={loading || !email} className="mt-6 w-full">
            {t('deleteAccount.submit')}
          </TwButton>
        </form>
      )}
    </DeleteAccountLayout>
  )
}
